module.exports = __webpack_public_path__ + "media/images/certificate/signature-d39caef55101db44f55dde2d24648e09.png";